/* eslint-disable */
import React, { useState } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useQuery } from '@tanstack/react-query';
import { RegularButton, Loader } from 'pg-ui-library';

import { MileageCreateModal } from './mileageCreateModal';
import {
  Container,
  ScreenHeader,
  RightHeader,
  PageTitle,
  EmptyContainer,
  CompanyHeader,
  CompanyContainer,
} from './styles';

import MileageService from 'src/services/mileage.service';
import ExternalClientUsersTab from '../settings/components/external-client-users-tab';

interface Mileage {
  id: string;
  country: string;
  currency: string;
  year: number;
  ratePerMile: number;
  active: boolean;
  createdAt: string;
}

const MileageList: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState<'mileage' | 'externalClientUsers'>('externalClientUsers');
  const [openModal, setOpenModal] = useState(false);

  const { data, isLoading, isFetching, refetch } = useQuery<Mileage[]>({
    queryKey: ['mileage-list'],
    queryFn: async () => {
      return await MileageService.getMileageList();
    },
    enabled: selectedTab === 'mileage',
  });

  const columns: GridColDef[] = [
    {
      field: 'country',
      headerName: 'Country',
      flex: 1,
    },
    {
      field: 'currency',
      headerName: 'Currency',
      flex: 1,
    },
    {
      field: 'year',
      headerName: 'Year',
      flex: 1,
    },
    {
      field: 'ratePerMile',
      headerName: 'Rate Per Mile',
      flex: 1,
    },
    {
      field: 'active',
      headerName: 'Status',
      flex: 1,
      renderCell: params => (params.value ? 'Active' : 'Inactive'),
    },
    {
      field: 'createdAt',
      headerName: 'Created At',
      flex: 1,
      renderCell: params => params.value || '',
    },
  ];

  const renderMileageContent = () => {
    if (isLoading || isFetching) {
      return (
        <EmptyContainer>
          <Loader />
        </EmptyContainer>
      );
    }

    if (data && data.length > 0) {
      return (
        <DataGrid
          rows={data}
          columns={columns}
          getRowId={row => row.id}
          autoHeight
          pageSizeOptions={[10, 20, 50]}
          sx={{
            font: '14px Biotif',
            fontWeight: 'bold',
            '& .CommonHeaderClass': {
              color: '#9399B2',
              font: '16px Biotif',
              fontWeight: 'bold',
            },
            minHeight: '150px',
            '& .MuiDataGrid-scrollbar--horizontal': {
              zIndex: 0,
            },
          }}
        />
      );
    }

    return (
      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        No Mileage records found. Click &quot;Create Mileage&quot; to add one.
      </div>
    );
  };

  return (
    <Container>
      <ScreenHeader>
        <PageTitle>Client Access & Mileage</PageTitle>
      </ScreenHeader>

      {/* Tabs */}
      <div
        style={{
          display: 'flex',
          gap: '10px',
          marginBottom: '20px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <button
          onClick={() => setSelectedTab('externalClientUsers')}
          style={{
            padding: '12px 20px',
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            fontSize: '16px',
            borderBottom: selectedTab === 'externalClientUsers' ? '3px solid #2E6EF7' : '3px solid transparent',
            fontWeight: selectedTab === 'externalClientUsers' ? 600 : 400,
          }}
        >
          External Client Users
        </button>
        <button
          onClick={() => setSelectedTab('mileage')}
          style={{
            padding: '12px 20px',
            border: 'none',
            background: 'transparent',
            fontSize: '16px',
            cursor: 'pointer',
            borderBottom: selectedTab === 'mileage' ? '3px solid #2E6EF7' : '3px solid transparent',
            fontWeight: selectedTab === 'mileage' ? 600 : 400,
          }}
        >
          Mileage
        </button>
      </div>

      {/* Mileage Tab */}
      {selectedTab === 'mileage' && (
        <>
          <MileageCreateModal isOpen={openModal} setIsOpen={setOpenModal} refetchMileage={refetch} />
          <CompanyContainer>
            <CompanyHeader>
              <h4>Mileage</h4>
              <RegularButton onClick={() => setOpenModal(true)}>Create Mileage</RegularButton>
            </CompanyHeader>
          </CompanyContainer>

          {renderMileageContent()}
        </>
      )}

      {/* External Client Users Tab */}
      {selectedTab === 'externalClientUsers' && <ExternalClientUsersTab />}
    </Container>
  );
};

export default MileageList;
